import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5",
  height: "5",
  viewBox: "0 0 5 5"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      id: "Ellipse_7",
      "data-name": "Ellipse 7",
      cx: "2.5",
      cy: "2.5",
      r: "2.5",
      fill: _ctx.color === 0 ? 'red' : 'blue'
    }, null, 8, _hoisted_2)
  ]))
}